import route from "@/components/router/Router"

export default {
    path : "company-profession-category",
    name : "company-profession-category",
    meta : {
        title : "专业类别管理",
    },
    redirect : {
        name : "company-profession-category-edit",
    },
    component: route,
    children : [
        {
            path: 'edit',
            name: 'company-profession-category-edit',
            meta: {
                title: '专业类别管理-单位管理'
            },
            component: () => import('@/pages/company/professionCategory/Index'),
        }
    ]
}



// WEBPACK FOOTER //
// ./src/router/company/professionCategory/index.js